import PageLayout from '@/components/feature/PageLayout';

export default function MentionsLegales() {
  return (
    <PageLayout>
      <div className="bg-black py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <h1 className="font-heading text-5xl md:text-7xl text-white leading-none text-center mb-[4.55rem] md:mb-[6.5rem]">
            Mentions légales
          </h1>

          <div className="flex flex-col gap-10 text-sm text-white/80 leading-relaxed">
            <section>
              <h2 className="font-heading text-lg text-white mb-3">Éditeur du site</h2>
              <p>
                Le site internet <strong className="text-white">romuald-designer.fr</strong> est édité par :
              </p>
              <p className="mt-2">
                <strong className="text-white">Romuald Roudaut</strong>
                <br />
                Artiste carreleur
                <br />
                Email : projets@romudesigner.fr
              </p>
            </section>

            <section>
              <h2 className="font-heading text-lg text-white mb-3">Directeur de la publication</h2>
              <p>Monsieur Romuald Roudaut</p>
            </section>

            <section>
              <h2 className="font-heading text-lg text-white mb-3">Hébergement</h2>
              <p>
                Le site est hébergé par : Ionos
                <br />
                Adresse : disponible sur demande
              </p>
            </section>

            <section>
              <h2 className="font-heading text-lg text-white mb-3">Propriété intellectuelle</h2>
              <p>
                L'ensemble du contenu de ce site (textes, images, photographies, logo, charte graphique)
                est la propriété exclusive de Romuald Roudaut. Toute reproduction, représentation,
                modification, publication, adaptation de tout ou partie des éléments du site, quel que soit
                le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-lg text-white mb-3">Crédits</h2>
              <p>
                <strong className="text-white">Conception :</strong> LL Signature
                <br />
                <strong className="text-white">Développement Web :</strong> BS Webdesign
              </p>
            </section>

            <section>
              <h2 className="font-heading text-lg text-white mb-3">Données personnelles</h2>
              <p>
                Les informations collectées via le formulaire de contact sont utilisées uniquement
                dans le cadre de la relation commerciale. Conformément au Règlement Général sur la
                Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification,
                de suppression et de portabilité de vos données. Pour exercer ces droits, contactez
                Romuald Roudaut à l'adresse contact@romuald-designer.fr.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-lg text-white mb-3">Cookies</h2>
              <p>
                Ce site utilise des cookies techniques nécessaires à son bon fonctionnement.
                Aucun cookie publicitaire ni de traçage tiers n'est déposé.
              </p>
            </section>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}